// extracted by mini-css-extract-plugin
export var drawerPaper = "_2m-0";
export var itemCard = "_2m-1";
export var itemImage = "_2m-2";